import axios from "axios";
import { findLanguage } from "@/utility/LocalizationService";
import BaseApi from "./baseApi";
import { DateTime } from "luxon";
export default class UserApi extends BaseApi {
  //
  // Deprecated:
  // Old login with username + organizationCode
  //
  login(username, password, organizationCode) {
    const th = this;
    return axios
      .post(
        `${this.url}/api/${organizationCode}/auth/login`,
        {
          Username: username,
          Password: password
        },
        {
          headers: {
            "content-type": "application/vnd.maestroconnect.username-login+json"
          }
        }
      )
      .then(response => {
        if (response && response.data && response.data.result) {
          const result = response.data.result;
          localStorage.token = result.token;
          localStorage.refreshToken = result.refreshToken;
          localStorage.language = findLanguage(result.user.Language).id;
          localStorage.userId = result.user.Id;
          DateTime.now().setLocale(localStorage.language.substring(0, 2));
          axios.defaults.headers.common["Authorization"] = "Bearer " + result.token;
          axios.defaults.headers.common["Accept-Language"] = localStorage.language;

          th.organizationCode = result.user.OrganizationCode;
          return result.user;
        } else return null;
      });
  }

  loginWithEmail(email, password) {
    const th = this;
    return axios
      .post(
        this.url + "/v2/auth/login",
        {
          Email: email,
          Password: password
        },
        {
          headers: {
            "content-type": "application/vnd.maestroconnect.email-login+json"
          }
        }
      )
      .then(response => {
        if (response && response.data && response.data.result) {
          const result = response.data.result;
          localStorage.token = result.token;
          localStorage.refreshToken = result.refreshToken;
          localStorage.language = findLanguage(result.user.Language).id;
          localStorage.userId = result.user.Id;
          DateTime.now().setLocale(localStorage.language.substring(0, 2));
          axios.defaults.headers.common["Authorization"] = "Bearer " + result.token;
          axios.defaults.headers.common["Accept-Language"] = localStorage.language;

          th.organizationCode = result.user.OrganizationCode;
          return result.user;
        } else return null;
      });
  }

  logout() {
    return axios.get(this.url + "/api/" + this.organizationCode + "/auth/logout").then(() => {
      // Clear all local storage
      localStorage.clear();
    });
  }

  resetPassword(email) {
    return axios.post(this.url + "/api/FAKE/auth/reset", email).then(() => {});
  }

  changePassword(id, password) {
    return axios
      .put(this.url + "/api/" + this.organizationCode + "/auth/changepassword/" + id, password)
      .then(response => {
        return response;
      });
  }

  getMe() {
    return axios
      .get(this.url + "/api/" + this.organizationCode + "/users/" + this.me)
      .then(response => {
        return response.data.result;
      });
  }

  getUser(userId) {
    return axios.get(this.url + "/api/" + this.organizationCode + "/users/" + userId);
  }

  getUsersList(search) {
    return axios
      .get(this.url + "/api/" + this.organizationCode + "/users", { params: search })
      .then(response => {
        return response.data;
      });
  }

  saveUser(user) {
    delete user.Notification_Ids;
    delete user.Machine_Group_Ids;
    delete user.Role_Ids;

    return axios
      .post(this.url + "/api/" + this.organizationCode + "/users", user)
      .then(response => {
        if (response && response.data && response.data.result) return response.data.result.user;
        else return null;
      });
  }

  saveExternalUser(user) {
    return axios.post(`${this.url}/api/${this.organizationCode}/users/sso`, user).then(response => {
      if (response && response.data && response.data.result) return response.data.result;
      else return null;
    });
  }

  updateUser(id, user) {
    return axios
      .put(this.url + "/api/" + this.organizationCode + "/users/" + id, user)
      .then(() => {});
  }

  /*
   * Update user email
   * @param Email
   */
  updateUserEmail(id, param) {
    return axios
      .patch(`${this.url}/api/${this.organizationCode}/users/${id}/email`, param)
      .then(() => {});
  }

  getUserGroups(id, search) {
    return axios
      .get(this.url + "/api/" + this.organizationCode + "/users/" + id + "/machinegroups", {
        params: search
      })
      .then(response => {
        if (response && response.data && response.data.result) return response.data.result;
        else return null;
      });
  }

  updateUserGroups(id, groups) {
    return axios
      .put(this.url + "/v2/" + this.organizationCode + "/users/" + id + "/machinegroups", groups)
      .then(function (result) {
        return result;
      });
  }

  updateUserRoles(id, roles) {
    return axios
      .put(this.url + "/api/" + this.organizationCode + "/users/" + id + "/roles", roles)
      .then(function (result) {
        return result;
      });
  }

  /**
   * Get user subscriptions
   * @returns {Object} { Maintenances: true, ...}
   *
   */
  getUserSubscriptions() {
    return axios.get(`${this.url}/api/users/${this.me}/subscriptions`).then(response => {
      if (response && response.data && response.data.result) return response.data.result;
      else return null;
    });
  }

  /**
   * Update user subscriptions
   * @param {Object} data { maintenances: true, ...}
   */
  updateUserSubscriptions(data) {
    return axios.patch(`${this.url}/api/users/${this.me}/subscriptions`, data).then(function () {
      return true;
    });
  }

  /**
   * Get user subscriptions channels
   * @returns {Object} { push: true, email:true ...}
   *
   */
  getUserSubscriptionsChannels() {
    return axios.get(`${this.url}/api/users/${this.me}/channels`).then(response => {
      if (response && response.data && response.data.result) return response.data.result;
      else return null;
    });
  }

  /**
   * Update user subscriptions
   * @param {Object} data { push:true, email:true, ...}
   */
  updateUserSubscriptionsChannels(data) {
    return axios.patch(`${this.url}/api/users/${this.me}/channels`, data).then(function () {
      return true;
    });
  }

  deleteUser(userId) {
    return axios.delete(this.url + "/api/" + this.organizationCode + "/users/" + userId);
  }

  getMachineGroupUsers(groupId, search) {
    return axios
      .get(`${this.url}/v2/${this.organizationCode}/machinegroups/${groupId}/users`, {
        params: search
      })
      .then(response => {
        return response.data;
      });
  }
}
